/**
 * lecsereli az osszes <a href> taget <router-link to> formara az SPA miatt
 * @param html
 * @return {string}
 */
export function replaceRouterLinks(html) {
  const wrapper = document.createElement('div')
  wrapper.innerHTML = html
  if (wrapper.querySelectorAll('a').length < 1) return html
  wrapper.querySelectorAll('a').forEach((anchor) => {
    let href = anchor.getAttribute('href')
    const bindHref = anchor.getAttribute(':href')
    href = href || bindHref
    if (
      href &&
      !(
        href.startsWith('http://') ||
        href.startsWith('https://') ||
        href.startsWith('mailto:') ||
        href.includes('ProcessBuilders')
      )
    ) {
      const routerLink = document.createElement('router-link')
      Array.from(anchor.attributes).forEach((attr) => {
        if (attr.name !== 'href') {
          routerLink.setAttribute(attr.name, attr.value)
        }
      })
      const to = !!bindHref ? ':to' : 'to'
      routerLink.setAttribute(to, href)
      routerLink.innerHTML = anchor.innerHTML
      anchor.parentNode.replaceChild(routerLink, anchor)
    }
  })
  return wrapper.innerHTML
}
